import {WKT} from "ol/format"
import {apiCall} from "@ui/api/common"
import {GeolocationPositionExt} from "@ui/stores/movement"

export const sendDebug = (trackId: string, data: GeolocationPositionExt[]) => apiCall()
	.post<void>(`/track/debug/${trackId}`, data)

export type TUserTrack = {
	id: number
	ts: Date
	user: string
	name: string
	start: number
	end: number
	track_id: number
	color?: number
	favorite?: boolean
}

type TSaveTrackParams = {
	points: GeolocationPosition[]
	name: string
	color: number
}

type TUpdateTrackParams = {
	id: number
	name: string
	color: number
}

export type TLoadTrack = {
  geometry: WKT
  props: {
    id: number
    ts: Date
    color: number
    start: number
    end: number
    name: string
    favorite: boolean
  }
}

type TSearchTrackParams = {
	page?: number
	size?: number
  filter: {
    name?: string | null
    color?: number | null
    favorite?: true | null
  }
}

export const save = ({points, name, color}: TSaveTrackParams): Promise<{id: number}> => apiCall()
	.post("/track/save", {
	  points: points.map(point => [
      point.coords.longitude,
      point.coords.latitude,
      Math.round(point.timestamp / 1000)
    ]),
	  props: {
	    name,
		  color,
	  }
	})

export const update = ({id, name, color}: TUpdateTrackParams): Promise<{id: number}> => apiCall()
	.post(`/track/update/${id}`, {name, color})

export const pageSize = 10
export const search = (
	{
		page = 0,
		size = pageSize,
    filter = {}
	}: TSearchTrackParams
): Promise<TUserTrack[]> => apiCall()
  .post("/track/search", {page, size, filter})

export const load = (id: number) => apiCall()
	.get<TLoadTrack>(`/track/load/${id}`)

export const purge = (id: number) => apiCall().delete(`/track/delete/${id}`)

export const mark = (id: number) => apiCall().patch<{favorite: boolean}>(`/track/mark/${id}`)
